(() => {
  function enhance(root) {
    if (root.dataset.hdArticleReady) return;
    // Preserve layout classes, inline dimensions and all merchant content.
    root.querySelectorAll('h1').forEach(old => {
      const heading = document.createElement('h2');
      for (const attr of old.attributes) heading.setAttribute(attr.name, attr.value);
      heading.append(...old.childNodes); old.replaceWith(heading);
    });
    function disclosure(button, panel) {
      if (!button || !panel) return;
      const details = document.createElement('details');
      details.className = 'hd-article-disclosure';
      const summary = document.createElement('summary');
      summary.textContent = button.textContent.trim();
      button.replaceWith(details); details.append(summary,panel);
    }
    root.querySelectorAll('button.accordion').forEach(button => {
      const panel = button.nextElementSibling;
      if (panel?.classList.contains('panel')) disclosure(button,panel);
    });
    disclosure(root.querySelector('#ostara-ritual-button'),root.querySelector('#ostara-ritual-steps'));
    disclosure(root.querySelector('.show-ritual-btn'),root.querySelector('#ritualSteps'));
    function panelGroup(selector, attribute, prefix) {
      const pairs = [...root.querySelectorAll(selector)].map(button => {
        const id = prefix + button.getAttribute(attribute);
        return {button,panel:root.querySelector('#' + CSS.escape(id))};
      }).filter(pair => pair.panel);
      pairs.forEach(pair => {
        const {button,panel} = pair;
        const label = button.contains(panel) ? button.querySelector('.ostara-crystal-name') : button;
        const control = document.createElement('button');
        control.type = 'button';
        control.className = label.className + ' hd-article-toggle';
        control.textContent = label.textContent.trim();
        label.replaceWith(control); pair.control = control;
        control.setAttribute('aria-controls',panel.id);
        control.setAttribute('aria-expanded','false'); panel.hidden = true;
        function toggle() {
          const open = panel.hidden;
          pairs.forEach(pair => {
            const active = open && pair.panel === panel;
            pair.panel.hidden = !active; pair.panel.classList.toggle('active',active);
            pair.control.setAttribute('aria-expanded',String(active));
          });
        }
        control.addEventListener('click',toggle);
      });
    }
    panelGroup('.ostara-crystal-card[data-crystal]','data-crystal','ostara-crystal-detail-');
    panelGroup('.ostara-phase[data-phase]','data-phase','ostara-phase-');
    root.dataset.hdArticleReady = 'true';
  }
  function setup(scope) { scope.querySelectorAll('[data-hd-article]').forEach(enhance); }
  setup(document); document.addEventListener('shopify:section:load',event => setup(event.target));
})();
